import React from 'react';
import Icon, { IconProps } from '../Icon';

const LogoutIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 42 51"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9194 0.602844H31.3376C36.7229 0.602844 41.1055 4.86913 41.1168 10.1115V41.0942C41.1168 46.3366 36.7229 50.6028 31.3489 50.6028H18.1447C17.1533 50.6028 16.3421 49.8132 16.3421 48.859C16.3421 47.8939 17.1533 47.1043 18.1447 47.1043H31.3376C34.7288 47.1043 37.5003 44.4173 37.5003 41.1051V10.1005C37.489 6.78841 34.74 4.10142 31.3376 4.10142H17.9194C16.9279 4.10142 16.1168 3.31177 16.1168 2.35762C16.1168 1.39249 16.9279 0.602844 17.9194 0.602844ZM23.9783 28.6579H5.6579L9.48129 32.4295C10.073 33.0131 10.073 33.956 9.48129 34.5397C8.88958 35.1234 7.93373 35.1234 7.34201 34.5397L0.935547 28.2201C0.343831 27.6364 0.343831 26.6936 0.935547 26.1099L7.34201 19.7903C7.93373 19.2066 8.88958 19.2066 9.48129 19.7903C10.073 20.374 10.073 21.3168 9.48129 21.9005L5.64652 25.6833L23.9783 25.6721H23.9897C24.8204 25.6833 25.4918 26.3456 25.4918 27.165C25.4918 27.9956 24.809 28.6579 23.9783 28.6579Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default LogoutIcon;
